import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  PackagePayload,
  PackageResponse,
} from '../../../components/admin-dashboard-component/orders/view-order-details/actions/package-order.model';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../auth-service';
import { ConfirmPackageRequestDto } from '../../../components/admin-dashboard-component/orders/view-order-details/actions/confirm-package.model';

@Injectable({
  providedIn: 'root',
})
export class OrderPackageService {
  private authService = inject(AuthService);

  private api = environment.pharmacyMgtApiUrl;
  private workFlowApi = environment.workflowApiUrl;

  private getHeaders(): HttpHeaders {
    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }

  constructor(private http: HttpClient) {}

  packageOrderItem(itemId: number, payload: PackagePayload): Observable<PackageResponse> {
    return this.http.put<PackageResponse>(`${this.api}/orders/items/${itemId}/package`, payload, {
      headers: this.getHeaders(),
    });
  }

  resetPackage(orderId: string): Observable<void> {
    return this.http.put<void>(`${this.api}/orders/${orderId}/reset/package`, null, {
      headers: this.getHeaders(),
    });
  }

  submitPackage(orderId: string, comment: string): Observable<void> {
    return this.http.put<void>(
      `${this.workFlowApi}/orders/${orderId}/submit/package`,
      { comment },
      {
        headers: this.getHeaders(),
      },
    );
  }

  confirmPackage(orderId: string, payload: ConfirmPackageRequestDto): Observable<void> {
    return this.http.put<void>(`${this.workFlowApi}/orders/${orderId}/package/confirm`, payload, {
      headers: this.getHeaders(),
    });
  }
}
